// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dd","pgUseBox":"dd","use-card-wrap":"de","useCardWrap":"de","use-box-wrap":"df","useBoxWrap":"df"};